import { render } from "./MainView.vue?vue&type=template&id=6db23544&ts=true"
import script from "./MainView.vue?vue&type=script&lang=ts"
export * from "./MainView.vue?vue&type=script&lang=ts"

import "./MainView.vue?vue&type=style&index=0&id=6db23544&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__